/* eslint-disable */
// prettier-ignore-start
import Button from '../../../../ntisui/Atoms/Buttons';
import { Link, useHistory } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { useMsal, useAccount } from '@azure/msal-react';
import { litrals } from '../../../../../constants/Litrals';
import { ButtonVariant } from '../../../template/types/IHeader';
import logo from '../../../../../assets/images/national-highways-logo.svg';
import {
  headerConstants,
  cookiesConstants,
} from '../../../../../constants/Constants';
import {
  getCookies,
  setCookies,
} from '../../../../../utils/LocalStorageManager';
import './_DataFeedPolicy.scss';

const DataFeedPolicy = () => {
  const history = useHistory();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const userId = (account && account.localAccountId) || '';

  const handleAcceptPolicy = () => {
    if (
      getCookies(`${cookiesConstants.ntisAddDataFeedCookieKey}-${userId}`) !==
      cookiesConstants.ntisAddDataFeedCookieValue
    )
      setCookies(
        `${cookiesConstants.ntisAddDataFeedCookieKey}-${userId}`,
        cookiesConstants.ntisAddDataFeedCookieValue,
      );
    history.push('availabledatafeed');
  };

  return (
    <>
      <Container className="subscriber-feed-main-container">
        <Row>
          <Col>
            <img
              alt={headerConstants.brandLogoText}
              src={logo}
              className="datafeed-policy-brand-logo"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <h3 className="main-heading" data-testid="datafeed-policy">
              Acceptable Use and Operational Policy for National Traffic
              Information Service (NTIS) Traffic Data
            </h3>
          </Col>
        </Row>
        <Row className="main-content">
          <Col>
            <ol>
              <li>
                Introduction
                <ol>
                  <li>
                    This document outlines the terms and conditions for the
                    access to and usage of the NTIS Traffic Data.
                  </li>
                  <li>
                    In this document:
                    <ol>
                      <li>
                        The “User” is defined as the person authorised by
                        National Highways who wishes to access and use the NTIS
                        Traffic Data and who agrees to abide by these terms and
                        conditions. Where a User is acting on behalf of a
                        company or organisation, the User is responsible for
                        ensuring that they have the full authority of that
                        company or organisation in respect of these terms and
                        conditions and will provide evidence of this authority
                        to National Highways if requested.
                      </li>
                      <li>
                        The “Administrator” is the administrator of the NTIS
                        Traffic Data appointed by National Highways.
                      </li>
                      <li>
                        The “NTIS Traffic Data” means a sub-set of the
                        information collected or produced by the NTIS service.
                      </li>
                      <li>
                        The “Integrated Data Service” means any data service
                        that the User makes available to third parties
                        (irrespective of the commercial terms on which it is
                        provided) which incorporates all or part of the NTIS
                        Traffic Data.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>

              <li>
                Conditions of Use
                <ol>
                  <li>
                    This document must be read and accepted by the User before
                    National Highways will grant access to the NTIS Traffic
                    Data.
                  </li>
                  <li>
                    The User shall be notified of activation of their right to
                    access the NTIS Traffic Data account via email.
                  </li>
                  <li>
                    The User will ensure that promotion of any Integrated Data
                    Service carries an acknowledgement of National Highways.
                  </li>
                </ol>
              </li>

              <li>
                Acceptable Use
                <ol>
                  <li>
                    The User shall not divulge their account credentials to any
                    other party or organisation. Multiple logins using the same
                    username are not permitted.
                  </li>
                  <li>
                    The User agrees that any information obtained or derived
                    from using NTIS Traffic Data (that would enable an
                    individual person to be identified) shall remain
                    confidential and that they will at all times comply with the
                    requirements of the Data Protection Act 2018.
                  </li>
                  <li>
                    Access to NTIS Traffic Data is granted partly on the basis
                    of a user’s employer and job role. Should the User leave
                    their current employment, they (or their
                    company/organisation) must notify the Administrator
                    immediately so that our records are updated. In the event
                    that the User’s company/organisation would require continued
                    access to NTIS Data, the account details may be modified
                    accordingly at the discretion of the Administrator. If a
                    User requires access to NTIS Data in their new role, he/she
                    must re-apply for authorisation.
                  </li>
                </ol>
              </li>
              <li>
                Operational Use
                <ol>
                  <li>
                    The User may use the NTIS Traffic Data either for
                    analysis/research purposes, as a source of information
                    within their own company or organisation, or as part of an
                    Integrated Data Service. In using the NTIS Traffic Data, the
                    User acknowledges that:
                    <ol>
                      <li>
                        Provision of NTIS Traffic Data is made without any
                        guarantee of integrity and level of service.{' '}
                      </li>
                      <li>
                        Provision of NTIS Traffic Data is made without any
                        warranty as to the content or accuracy of the NTIS Data.
                      </li>
                      <li>
                        The User is solely responsible for determining the
                        fitness for purpose of the NTIS Traffic Data in relation
                        to specific requirements and for the content of any
                        Integrated Data Service created using the NTIS Traffic
                        Data.
                      </li>
                    </ol>
                  </li>
                  <li>
                    The User agrees to provide National Highways with full
                    details on any Integrated Data Service. Where available, a
                    list of business users (including name, company or
                    organisation, email address and telephone numbers) of that
                    Integrated Data Service will help National Highways support
                    future investments in the NTIS.
                  </li>
                  <li>
                    National Highways reserves the right to change the content
                    or format of the NTIS Traffic Data. Should this happen,
                    National Highways will make every effort to provide the User
                    with notice of such changes.
                  </li>
                  <li>
                    The system administrator reserves the right to suspend
                    operation of the NTIS Traffic Data system to perform
                    maintenance operations.
                  </li>
                  <li>
                    The User undertakes not to publish or take part in any
                    negative publicity concerning either the NTIS or National
                    Highways arising out of their use of the NTIS Traffic Data.
                    Any such publicity would be dealt with under clause 6.3.1.
                  </li>
                </ol>
              </li>
              <li>
                Administration
                <ol>
                  <li>
                    The User accepts that its user details will be stored in a
                    secure database for administration purposes.
                  </li>
                </ol>
              </li>
              <li>
                Commercial
                <ol>
                  <li>
                    Whilst the NTIS Traffic Data is currently supplied to the
                    user without charge, Highways England reserves the right to
                    charge for the supply of NTIS Traffic Data at a future date.
                    Should it do so, National Highways will provide the User
                    with a minimum of 6 months’ notice of its intention to do so
                    together with the proposed charges. National Highways will
                    endeavour to provide 12 months’ notice if future charges for
                    NTIS Traffic Data are applied.
                  </li>
                  <li>
                    National Highways reserves the right to suspend or terminate
                    the supply of NTIS Traffic Data to a User for failure to
                    comply with these terms and conditions.
                  </li>
                  <li>
                    National Highways reserves the right to permanently cease
                    supply of the NTIS Traffic Data due to changes in policy or
                    as a result of abuse.
                    <ol>
                      <li>
                        Where supply is ceased due to abuse (which can include
                        inadvertent disruption of the Highway’s systems due to
                        incorrect operation or design of the User’s Interface
                        used to access the NTIS Traffic Data), such cessation
                        may take immediate effect.
                      </li>
                      <li>
                         Fused Traffic Data that has been fused by NTIS is now available to public and private sector.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>

              {/* <li>
                Further Information
                <ol>
                  <li>
                    New Subscribers must register for an account with NTIS
                    Subscriber portal at &nbsp;
                    <Link
                      data-testid="cookies-policy-link"
                      to="https://www.trafficengland.com"
                      className="underlined-colorlink"
                    >
                      https://www.trafficengland.com
                    </Link>
                  </li>
                  <li>
                    The Administrator can be contacted at the following email
                    address:
                  </li>
                  <li>
                    National Highways reserves the right to contact subscribers
                    on related matters.
                  </li>
                  <li>
                    NTIS Traffic Data can be accessed via{' '}
                    <Link
                      data-testid="cookies-policy-link"
                      to="https://www.data.gov.uk"
                      className="underlined-colorlink"
                    >
                      www.data.gov.uk
                    </Link>{' '}
                  </li>
                  <li>
                    Access to data from www.data.gov.uk is covered by the Open
                    Government Licence for public sector data found here: &nbsp;
                    <Link
                      data-testid="cookies-policy-link"
                      to="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3"
                      className="underlined-colorlink"
                    >
                      www.nationalarchives.gov.uk/doc/open-government-licence/version/3
                    </Link>
                  </li>
                </ol>
              </li> */}
            </ol>
            <Button
              data-testid="accept-policy-button"
              className="accept-policy-button"
              onClick={handleAcceptPolicy}
              variant={ButtonVariant.Primary}
              label={litrals.acceptPolicyText}
            />
            <Button
              data-testid="decline-policy-button"
              className="decline-policy-button"
              onClick={() => history.push('subscriberdatafeed')}
              variant={ButtonVariant.OutlinePrimary}
              label={litrals.declinePolicyText}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default DataFeedPolicy;
